import { render } from "./log-transfer.vue?vue&type=template&id=498aee92"
import script from "./log-transfer.vue?vue&type=script&lang=js"
export * from "./log-transfer.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__